import type { StructuredFilterGroupRequest } from "@/components/StructuredSearch";

export interface BackendStructuredFilterRequest {
  field: string;
  operator: string;
  value: unknown;
  nested_key?: string;
}

export interface BackendStructuredFilterGroupRequest {
  logic: "AND" | "OR";
  filters: (BackendStructuredFilterRequest | BackendStructuredFilterGroupRequest)[];
}

export interface RequestLogQueryPayload {
  q?: string;
  sort_by?: string;
  sort_order?: "asc" | "desc";
  filter_group?: BackendStructuredFilterGroupRequest;
  metadata_cost_breakdown_key?: string;
}

export const mapStructuredFilterGroupToBackend = (
  filterGroup?: StructuredFilterGroupRequest,
): BackendStructuredFilterGroupRequest | undefined => {
  if (!filterGroup) {
    return undefined;
  }

  return {
    logic: filterGroup.logic,
    filters: filterGroup.filters.map(filter =>
      "logic" in filter
        ? mapStructuredFilterGroupToBackend(filter)
        : {
            field: filter.field,
            operator: filter.operator,
            value: filter.value,
            ...(filter.nestedKey ? { nested_key: filter.nestedKey } : {}),
          },
    ) as (BackendStructuredFilterRequest | BackendStructuredFilterGroupRequest)[],
  };
};
